import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { CModal, CModalBody, CButton } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import { cilDelete } from '@coreui/icons';

import { setShowRemovePopup } from '../../../actions/general';

const RemovePopup = ({ id, visible, onClose, onAccept, loading, children, buttonText }) => {
     const dispatch = useDispatch();

     const isVisible = visible ?? true;

     const handleCancelButtonClick = () => {
          if (onClose) {
               onClose();
          } else {
               dispatch(setShowRemovePopup(null));
          }
     };

     const handleDeleteButtonClick = () => {
          if (id) {
               onAccept(id);
               return;
          }

          onAccept();
     };

     return (
          <>
               <CModal visible={isVisible} alignment="center" className="remove-popup">
                    <CModalBody className="text-center">
                         <CButton className="close-modal-button" onClick={handleCancelButtonClick} />
                         <div className="remove-popup-icon">
                              <CIcon icon={cilDelete} className="text-danger" height={38} alt="CoreUI Icons Delete" />
                         </div>
                         <h2>Are you sure?</h2>
                         <div className="remove-popup-description">{children}</div>
                         <div className="remove-popup-content">
                              <div className="btn-accept mb-3 position-relative">
                                   <CButton
                                        color="danger"
                                        className="text-uppercase d-inline-block"
                                        onClick={handleDeleteButtonClick}
                                        disabled={loading}
                                   >
                                        {loading ? (
                                             <>
                                                  Waiting
                                                  <span className="dots-waiting"></span>
                                             </>
                                        ) : (
                                             <>{buttonText || 'PROCEED TO DELETE'}</>
                                        )}
                                   </CButton>
                              </div>
                              <div className="mb-3 btn-cannel-cart">
                                   <CButton className="d-inline-block btn-cancel" onClick={handleCancelButtonClick} color="link">
                                        Cancel
                                   </CButton>
                              </div>
                         </div>
                    </CModalBody>
               </CModal>
          </>
     );
};

RemovePopup.propTypes = {
     id: PropTypes.string,
     visible: PropTypes.bool,
     onClose: PropTypes.func,
     onAccept: PropTypes.func,
     loading: PropTypes.bool,
};

export default RemovePopup;
